import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import {
  Container,
  ContentText,
  Text,
  ViewImages,
  Images,
  Title,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";

const SchoolSpecial = () => {

  const imagesGalery = [
    {
      original: images.edespecial1,
      thumbnail: images.edespecial1,
    },
    {
      original: images.edespecial2,
      thumbnail: images.edespecial2,
    },
    {
      original: images.edespecial3,
      thumbnail: images.edespecial3,
    },
    {
      original: images.edespecial4,
      thumbnail: images.edespecial4,
    },
    {
      original: images.edespecial5,
      thumbnail: images.edespecial5,
    }, 

  ];

  return (
    <Container>
      <Menu />
      <Banner icon={images.icon_autismo}>Educação Especial e Inclusiva</Banner>
      <ContentBox>
        
          <ViewImages>
            <Images>
              <ImageGallery 
              items={imagesGalery} 
              showBullets={true} 
              autoPlay={true} 
              showNav={false} 
              thumbnailPosition={"right"} 
              />
            </Images>
          </ViewImages>

          <ContentText>
            <Title>ESCOLA CLÍNICA TEA</Title>
            <Text> A Escola Clínica Transtorno do Espectro Autista – Profª Neuraide Rezende da Silva Fujita tem como 
              missão oferecer acolhimento humanizado e atendimento especializado a pessoas com Transtorno do Espectro 
              Autista (TEA) e seus responsáveis, promovendo ações inclusivas por meio de uma atuação intersetorial nas
              áreas da educação, saúde e assistência social. A instituição desenvolve práticas fundamentadas em evidências, 
              respeitando as especificidades do público atendido e assegurando o acesso a serviços que favoreçam o desenvolvimento 
              integral e a inclusão social. Para isso, conta com uma equipe multidisciplinar composta por médicos, psicólogos, 
              neuropsicóloga, fonoaudiólogos, terapeutas ocupacionais, psicomotricistas, nutricionista, supervisores clínicos, 
              atendentes terapêuticos, assistente social e enfermeira, garantindo uma abordagem integrada e centrada na 
              pessoa com TEA, fortalecendo o vínculo com as famílias e articulando-se com a rede de apoio.
            </Text>

            <Title>EMESP</Title>
            <Text>A Escola Municipal de Educação Especial Professora Jovita Franco Arouche desenvolve ações direcionadas à 
              identificação, elaboração e organização de recursos pedagógicos e de acessibilidade, com a finalidade de 
              eliminar barreiras que comprometam a plena participação de crianças e estudantes público-alvo da Educação 
              Especial no processo de ensino e aprendizagem, considerando suas necessidades educacionais específicas.
            </Text>

            <Text><li><b>AEE: </b>
              O Atendimento Educacional Especializado (AEE) configura-se como um serviço educacional de caráter complementar 
              e/ou suplementar ao ensino regular, destinado aos estudantes que compõem o público-alvo da Educação Especial. 
              Sua oferta ocorre, preferencialmente, em salas de recursos multifuncionais ou em ambientes educacionais 
              especializados, com a atuação de docentes com formação específica na área, bem como com o suporte de materiais
              pedagógicos acessíveis, recursos de acessibilidade e tecnologias assistivas. 
              O AEE tem como objetivo central identificar, eliminar ou minimizar as barreiras que comprometem o acesso, 
              a participação e a aprendizagem desses estudantes no ensino comum, assegurando, assim, uma inclusão educacional 
              efetiva e equitativa.</li>
            </Text>


            <Text><li><b>INTERVENÇÃO PRECOCE: </b>
              A Intervenção Precoce é o conjunto de ações sistematizadas voltadas ao desenvolvimento global da criança, 
              realizadas nos primeiros anos de vida, com o foco na estimulação de habilidades cognitivas, motoras, 
              comunicacionais e socioemocionais.</li>
            </Text>

            <Text><li><b>ATENDIMENTO DOMICILIAR E HOSPITALAR: </b>
              É um serviço de caráter temporário que assegura a continuidade do processo de escolarização de estudantes 
              impossibilitados de frequentar a escola em razão de tratamento médico ou condição de saúde.</li>
            </Text>

            <Title>PRÓ-ESCOLAR</Title>
            <Text>O Departamento de Orientação e Promoção/Pró-Escolar tem como finalidade oferecer serviços 
              especializados na área da educação, voltados à promoção de uma aprendizagem equitativa e inclusiva. Dentre 
              suas ações, destacam-se os atendimentos realizados no contraturno escolar, direcionados aos estudantes com 
              Necessidades Educacionais Específicas (NEE). Esses atendimentos visam favorecer o desenvolvimento 
              integral dos educandos, respeitando suas singularidades, garantindo equidade de acesso e permanência no 
              ambiente escolar, e estimulando a participação ativa no processo de ensino e aprendizagem. As Necessidades 
              Educacionais Específicas podem ser de caráter temporário ou permanente, abrangendo dimensões físicas, 
              sensoriais, intelectuais, emocionais ou sociais, e exigem, portanto, apoio educacional especializado 
              para assegurar a efetiva inclusão dos estudantes no contexto escolar.
            </Text>

        </ContentText>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default SchoolSpecial;